import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {
    DxButtonModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxScrollViewModule
} from "devextreme-angular";
import {
    StorageType,
    IBinDto,
    InventoryClient,
    UpdateBinCommand
} from '@services';
import notify from "devextreme/ui/notify";
import EnumUtils from "../../../../shared/enum-utils";
import {STORAGE_TYPE_CODES} from "../../../../shared/constants";

@Component({
    selector: 'app-bin-details',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxNumberBoxModule,
        DxScrollViewModule
    ],
    templateUrl: './bin-details.component.html',
    styleUrl: './bin-details.component.scss',
})
export class BinDetailsComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private inventoryClient = inject(InventoryClient);

    protected binNumber: string | null = null;
    protected bin: IBinDto = {};
    protected isLoading = false;

    protected storageTypeOptions = EnumUtils.getEnumOptions(StorageType);
    protected storageTypeCodeOptions = STORAGE_TYPE_CODES;
    protected storageBinTypeOptions = [
        'E2', 'B2', 'X6', 'X7', 'B1', 'X5', 'X8', 'E3', 'X9', 'B3', 'X2', 'X4', 'Y1', 'Y3', 'Y2', 'Y4', 'P1', 'X1', 'X3'
    ];
    protected zoneOptions = [
      'Cooler Racks',
      'Above Pick Cooler',
      'Dead End Floor Cooler',
      'QA Hold',
      'Lost',
      'Case Pick Aisles',
      'MRSL Locations',
      'Layer Pick Aisles',
      'EACH Pick Bins',
      'Ambient Rack Bins',
      'Ailse 45 Odd Bins "A" Only',
      'Ambient Drive In',
      'Inbound Staging Area',
      'Radio Shuttle Racks',
      'Returns',
      'Inbound Sorting Area'
    ];

    ngOnInit(): void {
        this.binNumber = this.route.snapshot.paramMap.get('number');
        if (this.binNumber) {
            this.loadBin();
        } else {
            notify('Bin Number missing', 'error', 3000);
            this.cancel();
        }
    }

    private loadBin() {
        this.isLoading = true;
        this.inventoryClient.getBin(this.binNumber!).subscribe({
            next: (data) => {
                this.bin = data;
                this.isLoading = false;
            },
            error: () => {
                notify('Failed to load bin', 'error', 3000);
                this.isLoading = false;
                this.location.back();
            }
        });
    }

    save() {
        const command = new UpdateBinCommand({
            number: this.binNumber!,
            storageTypeCode: this.bin.storageTypeCode,
            storageBinType: this.bin.storageBinType,
            storageType: this.bin.storageType,
            maxPallets: this.bin.maxPallets,
            aisle: this.bin.aisle,
            zone: this.bin.zone
        });

        this.inventoryClient.updateBin(command).subscribe({
            next: () => {
                notify('Bin updated successfully', 'success', 3000);
            },
            error: () => {
                notify('Failed to update bin', 'error', 3000);
            }
        });
    }

    cancel() {
        this.location.back();
    }
}
